/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Header from '@components/Header';
import Footer from '@components/Footer';
//  import './styles'

const Layout = ({ invertHeader, children, ...rest }) => {
  return (
    <div {...rest}>
      <Header invertHeader={invertHeader} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  invertHeader: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.node.isRequired
};

Layout.defaultProps = {
  invertHeader: false,
  delay: 0
};

export default Layout;
